let clientMiddleware

const loadWishList = () => {
  return {
    type: 'FETCH_WISHLIST',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'get',
        url: `/v1/participants/me/wishlist`
      }
    }
  }
}
const succesAddCart = skuId => ({
  type: 'ADD_CART_SUCCESS',
  skuId: skuId
})
const errorAddCart = skuId => ({
  type: 'ADD_CART_FAIL',
  skuId: skuId
})
const loadingAddCart = list => ({
  type: 'LOAD_ADD_CART_WISHLIST',
  skus: list
})

const addListToCart = list => {
  return async (dispatch, _) => {
    dispatch(loadingAddCart(list.map(item => item.skuId)))

    const handleSuccess = skuId => response => {
      if (response) dispatch(succesAddCart(skuId))
    }

    const handleError = skuId => () => {
      dispatch(errorAddCart(skuId))
    }

    for (let index = 0; index < list.length; index++) {
      const item = list[index]
      try {
        await clientMiddleware.post('/v1/carts/me/items', item)
        handleSuccess(item.skuId)
      } catch (_) {
        handleError(item.skuId)
      }
    }

    dispatch(succesAddCart(0))
  }
}

const removeWishlist = skuId => {
  return {
    type: 'REMOVE_WISHLIST',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'delete',
        url: `/v1/participants/me/wishlist/${skuId}/remove`,
        data: null
      }
    },
    skuId: skuId
  }
}

const removeWishlistCard = skuId => {
  return {
    type: 'REMOVE_WISHLIST_CARD',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'delete',
        url: `/v1/participants/me/wishlist/${skuId}/remove`,
        data: null
      }
    },
    skuId: skuId
  }
}

const addCart = (skuId, vendorId) => {
  return {
    type: 'ADD_WISHLIST_CART',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'post',
        url: `/v1/carts/me/items`,
        data: {
          ProductSkuId: skuId,
          Quantity: 1,
          vendorId: vendorId
        }
      }
    }
  }
}

const inWishlist = (skuId, vendorId) => {
  // Lista de Favoritos
}

const selectWishlist = (skuId, selected) => ({
  type: 'SELECT_WISHLIST',
  skuId: skuId,
  selected: selected
})

const selectAllWishlist = selected => {
  return {
    type: 'SELECT_ALL_WISHLIST',
    selected: selected
  }
}

export const addWishlist = skuId => {
  return {
    type: 'ADD_WISHLIST',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'put',
        url: `/v1/participants/me/wishlist/${skuId}/add`,
        data: null
      }
    },
    skuId: skuId
  }
}

export default client => {
  clientMiddleware = client
  return {
    removeWishlist,
    removeWishlistCard,
    loadWishList,
    addCart,
    addListToCart,
    selectWishlist,
    selectAllWishlist,
    addWishlist,
    inWishlist
  }
}



// WEBPACK FOOTER //
// ./src/Participant/Wishlist/actions.js